import { render } from "./ExchangeRateListing.vue?vue&type=template&id=5a140c2c&ts=true"
import script from "./ExchangeRateListing.vue?vue&type=script&lang=ts"
export * from "./ExchangeRateListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__